module.exports = __webpack_public_path__ + "23_cikm_3.jpg?94f4afc04d5096aaf7329d5b3ad5123c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_cikm_3.jpg
// module id = 198
// module chunks = 0